import request from '@/utils/request';

let messageApi = {
    // 消息列表
    getMessageList(data, err) {
        return request._postBody('/shop/ShopSystemMessage/pageList', data, err);
    },
    // 新增消息
    getAddMessage(data, err) {
        return request._postBody('/shop/ShopSystemMessage/add', data, err);
    },
    // 删除消息
    getDelMessage(data, err) {
        return request._postBody('/shop/ShopSystemMessage/delMessage', data, err);
    },

    // 选择用户
    getUser(data, err) {
        return request._get('/shop/user/user/selectList', data, err);
    },

    // 消息详情
    getMessageDetail(data, err) {
        return request._get('/shop/ShopSystemMessage/getDetail', data, err);
    }
}


export default messageApi;



// WEBPACK FOOTER //
// ./src/api/setting/message.js